/**
 *  PreloaderScene
 *
 *  Created by Legman on 7/10/2015.
 *
 */

"use strict";

//var Common = require("../Common");
import Application      from "../Application";
import Common from "../Common";

/**
 * @constructor
 * @extends {P3.Scene}
 */
function PreloaderScene() {

    /**
     * @type {number}
     * @private
     */
    this.loaded = 0;

    /**
     * @type {boolean}
     * @private
     */
    this._isPlayingAnim = false;

    /**
     * @type {PIXI.MovieClip}
     * @private
     */
    this._logoAnimation = null;

    /**
     * @type {PIXI.Sprite}
     * @private
     */
    this._bar = null;

    /**
     * @type {PIXI.Sprite}
     * @private
     */
    this._barOverlay = null;

    /**
     * @type {PIXI.Text}
     * @private
     */
    this._text = null;

    /**
     * @type {P3.Button}
     * @private
     */
    this._playButton = null;


    P3.Scene.call(this);


    this.signals.onAllLoaded = new signals.Signal();
}
export default PreloaderScene;
//module.exports = PreloaderScene;
PreloaderScene.prototype = Object.create(P3.Scene.prototype);
PreloaderScene.prototype.constructor = PreloaderScene;

PreloaderScene.prototype.init = function () {

    console.log(Common);
    console.log(Common.assets);

    var g = new PIXI.Graphics();
    g.beginFill(0x872F87);
    g.drawRect(0, 0, Common.STAGE_WIDTH, Common.STAGE_HEIGHT);
    g.endFill();
    this.addChild(g);

    var holder = new PIXI.Container();
    holder.x = Math.floor(Common.STAGE_WIDTH * 0.5);
    holder.y = Math.floor(Common.STAGE_HEIGHT * 0.5) + 50;
    this.addChild(holder);

    var logoFrames = [Common.assets.getTexture('loader_animation0001'),
        Common.assets.getTexture('loader_animation0002'),
        Common.assets.getTexture('loader_animation0003'),
        Common.assets.getTexture('loader_animation0004'),
        Common.assets.getTexture('loader_animation0005'),
        Common.assets.getTexture('loader_animation0006'),
        Common.assets.getTexture('loader_animation0007'),
        Common.assets.getTexture('loader_animation0008'),
        Common.assets.getTexture('loader_animation0009'),
        Common.assets.getTexture('loader_animation0010')
    ];

    this._logoAnimation = new PIXI.extras.MovieClip(logoFrames);
    this._logoAnimation.animationSpeed = 0.4;
    this._logoAnimation.gotoAndStop(0);
    this._logoAnimation.stop();
    this._logoAnimation.loop = false;
    this._logoAnimation.anchor.x = 0.5;
    this._logoAnimation.anchor.y = 1.0;
    this._logoAnimation.x += 50;
    this._logoAnimation.y -= 20;
    holder.addChild(this._logoAnimation);

    this._bar = new PIXI.Sprite(Common.assets.getTexture('preloader_bar'));
    this._bar.anchor.y = 0.5;
    this._bar.x -= this._bar.width * 0.5;
    this._bar.scale.x = 0;
    holder.addChild(this._bar);

    this._barOverlay = new PIXI.Sprite(Common.assets.getTexture('preloader_overlay'));
    this._barOverlay.anchor.y = 0.5;
    this._barOverlay.x -= this._barOverlay.width * 0.5;
    holder.addChild(this._barOverlay);

    this._text = new PIXI.Text("0%", {font: '28px Arial', 'fill': '#FFFFFF'});
    this._text.anchor.x = 0.5;
    this._text.position.y += 50;
    holder.addChild(this._text);

    // Start animation.
    this._logoAnimation.gotoAndPlay(0);

    var btnStatesAux = new P3.ButtonStates(
        Common.assets.getTexture("btn_primary_large_off"),
        Common.assets.getTexture("btn_primary_large_over"),
        Common.assets.getTexture("btn_primary_large_down"),
        Common.assets.getTexture("icon_play_large_off"));
    this._playButton = new P3.Button(btnStatesAux);
    this._playButton.y += 50;
    //this._playButton.downSoundName = "music_menu_playbtn_start_00";
    this._playButton.visible = false;
    this._playButton.signals.click.add(this._onPlayButtonClick, this);
    holder.addChild(this._playButton);
};

PreloaderScene.prototype.destroy = function () {
    P3.Scene.prototype.destroy.call(this);
};

PreloaderScene.prototype.appear = function () {
    this.animateIn();
};

PreloaderScene.prototype.show = function () {
};

PreloaderScene.prototype.animateIn = function (callback, scope) {

};

PreloaderScene.prototype.animateOut = function (callback, scope) {
};

PreloaderScene.prototype.resize = function () {
    this.x = (P3.View.width - Common.STAGE_WIDTH) * 0.5;
};

PreloaderScene.prototype.update = function () {
    this._bar.scale.x = this.loaded;
    this._text.text = Math.floor(this._bar.scale.x * 100) + '%';

    if (this.loaded == 1) {
        if (P3.Device.isMobile) {
            if (!this._playButton.visible) {
                this._playButton.visible = true;
                this._playButton.alpha = 0;

                TweenMax.to(this._playButton, 0.25, {alpha: 1, ease: Sine.easeOut});
                TweenMax.to(this._bar, 0.25, {alpha: 0, ease: Sine.easeIn});
                TweenMax.to(this._barOverlay, 0.25, {alpha: 0, ease: Sine.easeIn});
                TweenMax.to(this._text, 0.25, {alpha: 0, ease: Sine.easeIn});
            }
        }
        else
            this.signals.onAllLoaded.dispatch(this);
    }
};

/**
 * @param {P3.Button} button
 */
PreloaderScene.prototype._onPlayButtonClick = function (button) {
    this._playButton.interactive = false;

    // Try only android fullscreen. The fullscreen API is not supported by iOS Safari.
    if (P3.Device.isAndroid && screenfull.enabled) {
        screenfull.request();
        setTimeout(function () {
            Common.view.resize();
        }, 1000);
    }

    TweenMax.to(this._playButton, 0.25, {
        alpha: 0,
        ease: Sine.easeIn,
        onComplete: Application.init,
        onCompleteScope: this
    });
};
